import { toast } from "@veritrellis/ui";
import { humanizeApiError, parseApiError } from "./apiErrors.js";

export const showApiErrorToast = async (res: Response, input?: { fallbackTitle?: string }) => {
  const parsed = await parseApiError(res);
  const human = humanizeApiError(parsed);
  toast.show({
    title: input?.fallbackTitle ?? human.title,
    message: human.message,
    color: "red"
  });
};
